import { Search } from 'lucide-react';
import { Input, Checkbox, Card, CardContent } from '@roger/ui-components';
import { formatDateToISO, parseISOToLocalDate } from '../../utils/dateUtils';

export interface VisitCompletionByClinicianReportHeaderProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  fromDate: Date | null;
  toDate: Date | null;
  onFromDateChange: (value: Date | null) => void;
  onToDateChange: (value: Date | null) => void;
  showBreakdown: boolean;
  onShowBreakdownChange: (value: boolean) => void;
  hideNeverLoggedIn: boolean;
  onHideNeverLoggedInChange: (value: boolean) => void;
}

const VisitCompletionByClinicianReportHeader = ({
  searchTerm,
  onSearchTermChange,
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  showBreakdown,
  onShowBreakdownChange,
  hideNeverLoggedIn,
  onHideNeverLoggedInChange,
}: VisitCompletionByClinicianReportHeaderProps) => (
  <>
    <div className='text-sm text-[#735bd6] mb-2 -mt-2'>
      All data is from 08/25/2025 onward
    </div>

    <Card>
      <CardContent className='p-4'>
        <div className='flex gap-4 items-end flex-wrap'>
          <div className='relative flex-1 flex-grow'>
            <Search className='absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground' />
            <Input
              type='text'
              placeholder='Search by clinician name...'
              value={searchTerm}
              onChange={e => onSearchTermChange(e.target.value)}
              className='pl-10'
            />
          </div>

          <div className='w-40'>
            <label
              htmlFor='fromDate'
              className='text-sm font-medium mb-1.5 block'
            >
              From Date
            </label>
            <Input
              id='fromDate'
              type='date'
              value={fromDate ? formatDateToISO(fromDate) : ''}
              onChange={e => {
                onFromDateChange(
                  e.target.value
                    ? (parseISOToLocalDate(e.target.value) ?? null)
                    : null
                );
              }}
            />
          </div>

          <div className='w-40'>
            <label
              htmlFor='toDate'
              className='text-sm font-medium mb-1.5 block'
            >
              To Date
            </label>
            <Input
              id='toDate'
              type='date'
              value={toDate ? formatDateToISO(toDate) : ''}
              onChange={e => {
                onToDateChange(
                  e.target.value
                    ? (parseISOToLocalDate(e.target.value) ?? null)
                    : null
                );
              }}
            />
          </div>

          <div className='flex flex-col'>
            <div className='flex items-center gap-2'>
              <label className='flex items-center space-x-2'>
                <Checkbox
                  checked={showBreakdown}
                  onCheckedChange={checked => {
                    const v = !!checked;
                    onShowBreakdownChange(v);
                    localStorage.setItem(
                      'adoptionReport_showBreakdown',
                      JSON.stringify(v)
                    );
                  }}
                />
                <span className='text-sm'>Display visit type breakdown</span>
              </label>
            </div>

            <div className='flex items-center gap-2'>
              <label className='flex items-center space-x-2'>
                <Checkbox
                  checked={hideNeverLoggedIn}
                  onCheckedChange={checked => {
                    const v = !!checked;
                    onHideNeverLoggedInChange(v);
                    localStorage.setItem(
                      'adoptionReport_hideNeverLoggedIn',
                      JSON.stringify(v)
                    );
                  }}
                />
                <span className='text-sm'>Hide users who never logged in</span>
              </label>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  </>
);

export default VisitCompletionByClinicianReportHeader;
